export const IconSignature = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.16667 10.8333H12.8333C13.1095 10.8333 13.3333 11.0572 13.3333 11.3333C13.3333 11.6095 13.1095 11.8333 12.8333 11.8333H3.16667C2.89052 11.8333 2.66667 11.6095 2.66667 11.3333C2.66667 11.0572 2.89052 10.8333 3.16667 10.8333Z"
      fill="#EFE9E9"
    />
    <path
      d="M10.3567 2.85932C10.9775 2.23849 11.9841 2.23849 12.6049 2.85932L13.1407 3.39509C13.7615 4.01593 13.7615 5.0225 13.1407 5.64333L7.78997 10.9941C7.69622 11.0878 7.56904 11.1405 7.43645 11.1405H5.57465C5.29851 11.1405 5.07465 10.9166 5.07465 10.6405V8.77868C5.07465 8.64608 5.12733 8.5189 5.2211 8.42513L10.3567 2.85932ZM11.0638 3.56642L6.07465 8.98578V10.1405H7.22935L12.4336 4.93623C12.6639 4.70592 12.6639 4.33251 12.4336 4.1022L11.8978 3.56642C11.6675 3.33611 11.2941 3.33611 11.0638 3.56642Z"
      fill="#EFE9E9"
    />
    <path
      d="M2.88525 8.70336C3.09711 8.5263 3.41242 8.55452 3.58948 8.76638C3.77709 8.99086 4.02024 9.12789 4.26711 9.15374C4.54026 9.18233 4.82405 9.0818 5.07832 8.78129C5.25675 8.57059 5.57224 8.54443 5.78294 8.72286C5.99364 8.90129 6.0198 9.21678 5.84137 9.42748C5.39259 9.95786 4.79272 10.2163 4.16298 10.1504C3.55952 10.0872 3.08054 9.71638 2.82223 9.40759C2.64517 9.19572 2.67339 8.88042 2.88525 8.70336Z"
      fill="#EFE9E9"
    />
  </svg>
)
